import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalNotice = () => {
  return (
    <div className="min-h-screen bg-[#030303]">
      {/* Header */}
      <div className="border-b border-[#1C1C1C]">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#71717A] hover:text-[#A1A1AA] transition-colors text-sm"
          >
            <ArrowLeft size={16} />
            Retour
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <header className="mb-16 text-center">
          <h1 
            className="text-3xl md:text-4xl text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Mentions légales
          </h1>
          <p className="text-[#D4AF37] text-sm tracking-[0.2em] uppercase">
            Clierxter Vision Lab
          </p>
        </header>

        <div className="space-y-12 text-[#A1A1AA] leading-relaxed">
          
          {/* Section 1 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              1. Éditeur du site
            </h2>
            <p className="mb-4">
              Clierxter Vision Lab est une plateforme éditée par :
            </p>
            <div className="bg-[#0A0A0A] border border-[#1C1C1C] p-6">
              <p className="text-white mb-2">Manuela Ellis Manda</p>
              <p>
                Email : <a href="mailto:hello@clierxterapp.com" className="text-[#D4AF37] hover:underline">hello@clierxterapp.com</a>
              </p>
            </div>
            <p className="mt-4 text-[#71717A] text-sm">
              (Informations complètes pouvant être mises à jour ultérieurement)
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              2. Hébergement
            </h2>
            <p className="mb-4">
              Le site est hébergé par :
            </p>
            <div className="bg-[#0A0A0A] border border-[#1C1C1C] p-6">
              <p className="text-white">Emergent</p>
              <p className="text-[#71717A] text-sm mt-1">(plateforme de développement et hébergement SaaS)</p>
            </div>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              3. Propriété intellectuelle
            </h2>
            <p className="mb-4">
              L'ensemble des contenus présents sur la plateforme (textes, images, visuels, outils, branding) est la propriété exclusive de Clierxter Vision Lab.
            </p>
            <p>
              Toute reproduction, distribution ou utilisation sans autorisation est strictement interdite.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              4. Responsabilité
            </h2>
            <p className="mb-4">
              Clierxter Vision Lab met tout en œuvre pour fournir des informations fiables.
            </p>
            <p>
              Cependant, aucune garantie n'est donnée quant à l'exactitude ou l'exhaustivité des contenus.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              5. Contact
            </h2>
            <p className="mb-4">
              Pour toute question, vous pouvez nous contacter à :
            </p>
            <a 
              href="mailto:hello@clierxterapp.com" 
              className="inline-block bg-[#0A0A0A] border border-[#1C1C1C] px-6 py-3 text-[#D4AF37] hover:border-[#D4AF37]/30 transition-colors"
            >
              hello@clierxterapp.com
            </a>
          </section>

        </div>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-[#1C1C1C] text-center">
          <p className="text-[#52525B] text-sm">
            Clierxter Vision Lab
          </p>
        </footer>
      </div>
    </div>
  );
};

export default LegalNotice;
